import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';
import { QueryRoute, RouteStore } from 'bernie-core';

import { AmenityViewModel } from 'models';

import { classNames } from 'uitk-react-utils';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

import { InfoDialog } from 'components/common/info-dialog';

const LinkTracked = ClickTracker(Link);

export interface AmenityProps {
  amenity?: AmenityViewModel;
  index: number;
  onDismiss: () => void;
  routeStore?: RouteStore;
  small?: boolean;
  spacing?: string;
  triggerDialogId?: string;
  unique?: string;
  useMiniDialog?: boolean;
}

export const Amenity: React.FunctionComponent<AmenityProps> = ({
  amenity,
  index,
  onDismiss,
  routeStore,
  small,
  spacing,
  triggerDialogId,
  unique,
  useMiniDialog
}) => {
  const info = amenity.additionalInformation;
  const amenityDescription = amenity.description;
  const amenityHeader = amenity.headerText;
  const amenitySubDescription = amenity.subDescription;
  const amenityIcon = amenity.icon;
  const iconProps = amenityIcon
    ? {
        name: amenityIcon,
        className: 'uitk-cell all-cell-shrink',
        size: small ? UitkIconSize.SMALL : undefined
      }
    : null;
  const baseItemClasses = 'uitk-grid amenities-list__item';

  if (info) {
    const id = `${unique}-${index}`;
    const param =
      triggerDialogId === 'infosite-room-info-dialog-ratePlans' ? { pwaDialogNested: `addinfo-${id}` } : { pwaDialog: `addinfo-${id}` };
    const query = routeStore.mergeQueryString(routeStore.search, param);

    const infoDialogProps = {
      title: amenityHeader || amenityDescription,
      onClose: onDismiss,
      useMiniDialog,
      info
    };

    return (
      <li className={`${baseItemClasses} ${spacing || ''}`} key={`amenities-list-${index}-${amenityDescription}`}>
        <LinkTracked
          to={{ pathname: routeStore.pathname, search: query }}
          linkName="Open Special Deals Info Dialog"
          rfrr=".specialdealsinfo"
        >
          {iconProps && <UitkIcon {...iconProps} className="pwa-theme--grey-700" />}
          <span className="uitk-cell all-cell-3-4 amenities-list__item-title pwa-theme--grey-700">{amenityDescription}</span>
          <UitkIcon name="info_outline" size={UitkIconSize.SMALL} className="all-x-margin-two" />
        </LinkTracked>
        <QueryRoute query={param}>
          <Layer id={`${triggerDialogId}-${id}`} onDismiss={onDismiss}>
            <InfoDialog {...infoDialogProps} />
          </Layer>
        </QueryRoute>
      </li>
    );
  }

  const itemClass = classNames(baseItemClasses, `all-r-padding-three ${spacing || ''}`, {
    'all-b-margin-one': !spacing && small,
    'all-b-margin-three': !spacing && !small
  });

  return (
    <li className={itemClass} key={`amenities-list-${index}-${amenityDescription}`}>
      {iconProps && <UitkIcon {...iconProps} />}
      <span className="uitk-cell all-cell-3-4 all-cell-shrink amenities-list__item-title">
        {amenityDescription}
        {amenitySubDescription && <br />}
        {amenitySubDescription}
      </span>
    </li>
  );
};
